<template>
    <div>
      <div>
        <el-table
            :data= "data"
            stripe
            >
            <el-table-column
              type="selection"
              width="55">
            </el-table-column>
            <el-table-column
                prop="theNameOfTheTopic"
                label="题名"
                >
            </el-table-column>
            <el-table-column
                prop="author"
                label="作者"
                >
            </el-table-column>
            <el-table-column
                prop="source"
                label="来源"
                >
            </el-table-column>
            <el-table-column
                prop="date"
                label="发表时间"
                >
            </el-table-column>
            <el-table-column
                prop="dataBase"
                label="数据库"
                >
            </el-table-column>
            <el-table-column
                prop="used"
                label="被引"
                >
            </el-table-column>
            <el-table-column
                prop="download"
                label="下载"
                >
            </el-table-column>
            <el-table-column
                prop="operation"
                label="操作"
                >
                <template slot-scope="scope">
                  <el-button @click="handleClick(scope.row)" type="text" size="small"><i class="el-icon-download"></i></el-button>
                  <el-button type="text" size="small"><i class="el-icon-reading"></i></el-button>
                  <el-button type="text" size="small"><i class="el-icon-folder-opened"></i></el-button>
                  <el-button type="text" size="small"><i class="el-icon-link"></i></el-button>
                </template>
            </el-table-column>
        </el-table>
      </div>

        <div style="position: relative; top: 30px">
          <el-pagination style="text-align: center; height: 100px"
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="currentPage1"
            :page-size="10"
            layout="total, prev, pager, next"
            :total="100">
          </el-pagination>
        </div>
      
      <div style="text-align: center; height: 200px;width:120%">
            <el-row>
            <el-col :span="2" v-if='searchList.length > 0'><el-link :underline="false" style= 'color:galy'>相关搜索:</el-link></el-col>
                <el-col :span="3" v-if='searchList.length > 0'><el-link :underline="false" class= 'js'>{{this.searchList[0]}}</el-link></el-col>
                <el-col :span="3" v-if='searchList.length > 1'><el-link :underline="false" class= 'js'>{{this.searchList[1]}}</el-link></el-col>
                <el-col :span="3" v-if='searchList.length > 2'><el-link :underline="false" class= 'js'>{{this.searchList[2]}}</el-link></el-col>
                <el-col :span="3" v-if='searchList.length > 3'><el-link :underline="false" class= 'js'>{{this.searchList[3]}}</el-link></el-col>
                <el-col :span="3" v-if='searchList.length > 4'><el-link :underline="false" class= 'js'>{{this.searchList[4]}}</el-link></el-col>
                <el-col :span="3" v-if='searchList.length > 5'><el-link :underline="false" class= 'js'>{{this.searchList[5]}}</el-link></el-col>
                <el-col :span="3" v-if='searchList.length > 5'><el-link :underline="false" class= 'js'>{{this.searchList[6]}}</el-link></el-col>
            </el-row>
            <el-row v-if='searchList.length > 7'>
                <el-col :span="3" :offset="2" v-if='searchList.length > 7'><el-link :underline="false" class= 'js'>{{this.searchList[7]}}</el-link></el-col>
                <el-col :span="3" v-if='searchList.length > 8'><el-link :underline="false" class= 'js'>{{this.searchList[8]}}</el-link></el-col>
                <el-col :span="3" v-if='searchList.length > 9'><el-link :underline="false" class= 'js'>{{this.searchList[9]}}</el-link></el-col>
                <el-col :span="3" v-if='searchList.length > 10'><el-link :underline="false" class= 'js'>{{this.searchList[10]}}</el-link></el-col>
                <el-col :span="3" v-if='searchList.length > 11'><el-link :underline="false" class= 'js'>{{this.searchList[11]}}</el-link></el-col>
                <el-col :span="3" v-if='searchList.length > 12'><el-link :underline="false" class= 'js'>{{this.searchList[12]}}</el-link></el-col>
                <el-col :span="3" v-if='searchList.length > 13'><el-link :underline="false" class= 'js'>{{this.searchList[13]}}</el-link></el-col>
            </el-row>
        </div>
    </div>
</template>

<script>
import '../assets/font_2785867_3udo2xistp8/iconfont.css';
export default ({
    data() {
        return{
            data: [{
                date: '2015-09-02',
                author: '刘陈风',
                theNameOfTheTopic: '2015-藏北无人区百日科考纪行',
                source: '期刊',
                dataBase: '期刊',
                used: '',
                download: '',
                operation: ''
                }, {
                date: '2009-09-02',
                author: '	王辉',
                theNameOfTheTopic: '雅鲁藏布大峡谷穿越纪实_合并版',
                source: '期刊',
                dataBase: '期刊',
                used: '',
                download: '',
                operation: ''
                }, {
                date: '2001-09-02	',
                author: '	税晓洁',
                theNameOfTheTopic: '雅鲁藏布江漂流历险记',
                source: '期刊',
                dataBase: '期刊',
                used: '',
                download: '',
                operation: ''
                }, {
                date: '1999-12-02	',
                author: '	董月玲',
                theNameOfTheTopic: '他发现了大峡谷：科学探险家杨逸畴',
                source: '期刊',
                dataBase: '期刊',
                used: '',
                download: '',
                operation: ''
            }, {
                date: '2014-04-02	',
                author: '	杨逸畴',
                theNameOfTheTopic: '领悟世界之最',
                source: '期刊',
                dataBase: '期刊',
                used: '',
                download: '',
                operation: ''
            }, {
                date: '2001-09-01	',
                author: '张文敬',
                theNameOfTheTopic: '张文敬_大峡谷冰川考察记',
                source: '期刊',
                dataBase: '期刊',
                used: '',
                download: '',
                operation: ''
            }, {
                date: '2000-09-01	',
                author: '陶宝祥',
                theNameOfTheTopic: '陶宝祥_走入大峡谷的人们',
                source: '期刊',
                dataBase: '期刊',
                used: '',
                download: '',
                operation: ''
            }, {
                date: '1991-06-01',
                author: '杨逸畴等',
                theNameOfTheTopic: '“神山奇水探奥秘西藏南迦巴瓦峰地区科学考察散记',
                source: '期刊',
                dataBase: '期刊',
                used: '',
                download: '',
                operation: ''
            }, {
                date: '1992-08-28	',
                author: '章振根;刘玉海;王天武;杨惠心;徐宝慈',
                theNameOfTheTopic: '南迦巴瓦峰地区地质',
                source: '期刊',
                dataBase: '期刊',
                used: '',
                download: '',
                operation: ''
            }, {
                date: '1995-09-00',
                author: '	金辉',
                theNameOfTheTopic: '《西藏墨脱的诱惑——神秘奇险的高原边地之旅》',
                source: '期刊',
                dataBase: '期刊',
                used: '',
                download: '',
                operation: ''
            }
            ],
            searchList: ["世界无人区","阿尔金无人区","羌塘无人区","无人区里的鹰隼","无人区评价","无人区地方","无人区真的那么乱吗","无人区经历","无人区真实事件","世界最恐怖的无人区","伊朗无人区","世界无人区排行榜","四大无人区面积排名","中国无人区面积"],
            src: "../../../static/src=http___bpic.588ku.com_back_pic_05_75_17_055bd8fd5bda7d3.jpg&refer=http___bpic.588ku.jpg",
            currentPage1:1
        }
    },
    methods:{
      handleCurrentChange(){

      },
      handleSizeChange(){
        
      }
    }
})
</script>
<style scoped>
  .verticalBar {
        width: 1px;
        height: 150px;
        background: rgb(73, 73, 73);
        display: inline-block;
        margin-top: 31px;
        vertical-align: top;
        margin-right: 29px;
        margin-left: 30px;
        position:relative; 
        z-index:2; 
        left:1000px; 
        top:-550px
    }
    .ms{
      font-size: 10px;
    }
    .ls{
      font-size: 5px
    }
    .iconfont{
      font-size: 40px;
    }
    .js{
      color: rgb(69, 163, 207)
    }
</style>